import { noop } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { thoughtsQueryOptions } from "@/entities/thoughts"
import { DiaryListPage } from "@/pages/diary"
import { PendingComponent } from "@/shared/ui/pending-component"

export const Route = createFileRoute("/_authenticated/diary/")({
	loader: ({ context }) => {
		const { userId } = context

		// Preload thoughts (non-blocking)
		void context.queryClient.query(thoughtsQueryOptions(userId)).catch(noop)
	},
	component: DiaryListPage,
	pendingComponent: PendingComponent,
})
